
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import LawEnforcementSection from './components/LawEnforcementSection';
import ConstructionManagementSection from './components/ConstructionManagementSection';
import ServicesSection from './components/ServicesSection';
import TechnologySection from './components/TechnologySection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <LawEnforcementSection />
        <ConstructionManagementSection />
        <ServicesSection />
        <TechnologySection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
